import { render, staticRenderFns } from "./WarehouseMonitoringConfig.vue?vue&type=template&id=1637d2af&scoped=true"
import script from "./WarehouseMonitoringConfig.vue?vue&type=script&lang=js"
export * from "./WarehouseMonitoringConfig.vue?vue&type=script&lang=js"
import style0 from "./WarehouseMonitoringConfig.vue?vue&type=style&index=0&id=1637d2af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1637d2af",
  null
  
)

export default component.exports